var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHexagonWarningGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 39,
    viewBox: "0 0 43 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bii_337_44893)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.47564 23.0858C0.174786 20.8516 0.174786 18.1011 1.47564 15.867L8.32861 4.09743C9.63311 1.85704 12.0474 0.47638 14.6606 0.47638L28.3394 0.47638C30.9526 0.47638 33.3669 1.85704 34.6714 4.09743L41.5244 15.867C42.8252 18.1011 42.8252 20.8516 41.5244 23.0858L34.6714 34.8553C33.3669 37.0957 30.9526 38.4764 28.3394 38.4764L14.6606 38.4764C12.0474 38.4764 9.63311 37.0957 8.32861 34.8553L1.47564 23.0858Z",
    fill: "#A7A7A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.96832 22.2166C1.98026 20.5197 1.98026 18.4331 2.96832 16.7361L9.82129 4.96656C10.8134 3.26273 12.6562 2.20365 14.6606 2.20365L28.3394 2.20365C30.3438 2.20365 32.1866 3.26273 33.1787 4.96656L40.0317 16.7361C41.0197 18.4331 41.0197 20.5197 40.0317 22.2166L33.1787 33.9862C32.1866 35.69 30.3438 36.7491 28.3394 36.7491L14.6606 36.7491C12.6562 36.7491 10.8134 35.69 9.82129 33.9862L2.96832 22.2166Z",
    stroke: "#A7A7A7",
    strokeWidth: 3.45455
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2383 28.2132L21.2383 19.1563M21.2383 11.9325V11.9764",
    stroke: "#19191E",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bii_337_44893",
    x: -27.9422,
    y: -27.9659,
    width: 98.8845,
    height: 94.8845,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 14.2211
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_337_44893"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_337_44893",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.37573
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.18786
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_337_44893"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 37.1937
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_337_44893",
    result: "effect3_innerShadow_337_44893"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHexagonWarningGray);
export default __webpack_public_path__ + "static/media/hexagon-warning-gray.e2718cb536408a6b0e4eb51d30d612c9.svg";
export { ForwardRef as ReactComponent };